import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { AssignmentType } from './assignment-type';
export var SubmissionGradingStatus;

(function (SubmissionGradingStatus) {
  SubmissionGradingStatus["NOT_GRADED"] = "1";
  SubmissionGradingStatus["GRADING"] = "2";
  SubmissionGradingStatus["GRADED"] = "3";
  SubmissionGradingStatus["REJECTED"] = "4";
  SubmissionGradingStatus["GRADE"] = "grade";
  SubmissionGradingStatus["LEGACY_GRADE"] = "grade";
})(SubmissionGradingStatus || (SubmissionGradingStatus = {}));

var toTimestampInMilliseconds = function toTimestampInMilliseconds(timestamp) {
  if (timestamp == null) return null;
  var normalizedTimestamp = String(timestamp).trim();
  var numericTimestamp = Number(normalizedTimestamp);
  if (!normalizedTimestamp || !Number.isFinite(numericTimestamp)) return null;
  return normalizedTimestamp.length === 10 ? numericTimestamp * 1000 : numericTimestamp;
};

export var isUnlimitedExaminationAssignment = function isUnlimitedExaminationAssignment(assignment) {
  var _assignment$type;

  return (assignment === null || assignment === void 0 ? void 0 : (_assignment$type = assignment.type) === null || _assignment$type === void 0 ? void 0 : _assignment$type.id) === AssignmentType.Examination && assignment.startTime == null && assignment.endTime == null;
};
export var getExaminationSubmissionExpiryTimestamp = function getExaminationSubmissionExpiryTimestamp(assignment, submission) {
  var _assignment$type2, _assignment$completed;

  if ((assignment === null || assignment === void 0 ? void 0 : (_assignment$type2 = assignment.type) === null || _assignment$type2 === void 0 ? void 0 : _assignment$type2.id) !== AssignmentType.Examination) return null;
  var submissionExpiredAt = toTimestampInMilliseconds(submission === null || submission === void 0 ? void 0 : submission.expiredAt); // The server deadline includes the original schedule and remains authoritative after edits.

  var completedAt = toTimestampInMilliseconds(assignment === null || assignment === void 0 ? void 0 : assignment.completedAt);
  if (submissionExpiredAt != null) return completedAt == null ? submissionExpiredAt : Math.min(submissionExpiredAt, completedAt);
  var assignmentEndTime = toTimestampInMilliseconds((_assignment$completed = assignment.completedAt) !== null && _assignment$completed !== void 0 ? _assignment$completed : assignment.endTime);
  var submissionCreatedAt = toTimestampInMilliseconds(submission === null || submission === void 0 ? void 0 : submission.createdAt);
  var duration = assignment.duration;
  var durationInMilliseconds = duration != null && duration > 0 ? duration * 60 * 1000 : null;
  var calculatedSubmissionExpiredAt = submissionCreatedAt != null && durationInMilliseconds != null ? submissionCreatedAt + durationInMilliseconds : null;
  var attemptExpiredAt = submissionExpiredAt !== null && submissionExpiredAt !== void 0 ? submissionExpiredAt : calculatedSubmissionExpiredAt;
  var expiryCandidates = [attemptExpiredAt, assignmentEndTime].filter(function (timestamp) {
    return timestamp != null;
  });
  return expiryCandidates.length > 0 ? Math.min.apply(Math, _toConsumableArray(expiryCandidates)) : null;
};
export var isExaminationSubmissionExpired = function isExaminationSubmissionExpired(assignment, submission) {
  var nowInMilliseconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  if (submission !== null && submission !== void 0 && submission.closedAt) return true;
  var expiryTimestamp = getExaminationSubmissionExpiryTimestamp(assignment, submission);
  return expiryTimestamp != null && expiryTimestamp <= nowInMilliseconds;
};
export var getSubmissionGradingStatusId = function getSubmissionGradingStatusId(gradingStatus) {
  if (typeof gradingStatus === 'string') return gradingStatus;

  if (typeof (gradingStatus === null || gradingStatus === void 0 ? void 0 : gradingStatus.id) === 'string' || typeof (gradingStatus === null || gradingStatus === void 0 ? void 0 : gradingStatus.id) === 'number') {
    return gradingStatus.id.toString();
  }

  return undefined;
};
export var isSubmissionAcceptedForGrading = function isSubmissionAcceptedForGrading(gradingStatus) {
  var _getSubmissionGrading;

  var statusId = (_getSubmissionGrading = getSubmissionGradingStatusId(gradingStatus)) === null || _getSubmissionGrading === void 0 ? void 0 : _getSubmissionGrading.toLowerCase();
  return statusId === SubmissionGradingStatus.GRADING || statusId === SubmissionGradingStatus.GRADED || statusId === SubmissionGradingStatus.LEGACY_GRADE;
};
export var isSubmissionWaitingForGradingDecision = function isSubmissionWaitingForGradingDecision(gradingStatus) {
  var statusId = getSubmissionGradingStatusId(gradingStatus);
  return statusId == null || statusId === SubmissionGradingStatus.NOT_GRADED;
};
export var isSubmissionGrading = function isSubmissionGrading(gradingStatus) {
  return getSubmissionGradingStatusId(gradingStatus) === SubmissionGradingStatus.GRADING;
};
export var isSubmissionRejected = function isSubmissionRejected(gradingStatus) {
  return getSubmissionGradingStatusId(gradingStatus) === SubmissionGradingStatus.REJECTED;
};
export var hasSubmissionSubmitTime = function hasSubmissionSubmitTime(submitTime) {
  return submitTime != null && String(submitTime).trim().length > 0;
};
export var isSubmissionGradingTerminal = function isSubmissionGradingTerminal(gradingStatus) {
  var statusId = getSubmissionGradingStatusId(gradingStatus);
  return statusId === SubmissionGradingStatus.GRADED || statusId === SubmissionGradingStatus.REJECTED;
};
export var isExpiredTimestamp = function isExpiredTimestamp(expiredAt) {
  var nowInMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  if (!expiredAt) return false;
  var numericTimestamp = Number(expiredAt);
  if (!Number.isFinite(numericTimestamp)) return false;
  var expiredAtInMilliseconds = expiredAt.length === 10 ? numericTimestamp * 1000 : numericTimestamp;
  return expiredAtInMilliseconds < nowInMilliseconds;
};